var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBalloons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.616,
    x2: 405.616,
    xlinkHref: "#lg1",
    y1: 394.666,
    y2: 394.666
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.041,
    x2: 407.405,
    xlinkHref: "#lg2",
    y1: 346.959,
    y2: 393.322
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.717,
    x2: 366.743,
    xlinkHref: "#lg3",
    y1: 402.95,
    y2: 328.976
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.802,
    x2: 488.723,
    xlinkHref: "#lg2",
    y1: 173.634,
    y2: 306.081
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 390,
    x2: 390,
    xlinkHref: "#lg3",
    y1: 278.5,
    y2: 351.11
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 456.197,
    x2: 347.197,
    xlinkHref: "#lg3",
    y1: 275.263,
    y2: 224.763
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.616,
    x2: 270.616,
    xlinkHref: "#lg1",
    y1: 418.5,
    y2: 418.5
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.616,
    x2: 149.616,
    xlinkHref: "#lg1",
    y1: 433.999,
    y2: 433.999
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#af66da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6764,
    stopColor: "#a660cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    stopColor: "#8d51b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#6f3f8a"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.041,
    x2: 272.405,
    xlinkHref: "#lg4",
    y1: 321.292,
    y2: 367.655
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f3f8a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f3f8a"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.717,
    x2: 231.743,
    xlinkHref: "#lg5",
    y1: 377.283,
    y2: 303.309
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.326,
    x2: 368.326,
    xlinkHref: "#lg4",
    y1: 77.049,
    y2: 236.049
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 253,
    y2: 355.772
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.532,
    x2: 234.865,
    xlinkHref: "#lg5",
    y1: 324.031,
    y2: 268.031
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.45,
    x2: 149.356,
    xlinkHref: "#lg6",
    y1: 381.56,
    y2: 422.466
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.747,
    x2: 113.481,
    xlinkHref: "#lg7",
    y1: 430.96,
    y2: 365.694
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.174,
    x2: 226.688,
    xlinkHref: "#lg6",
    y1: 186.395,
    y2: 352.909
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 134,
    x2: 134,
    xlinkHref: "#lg7",
    y1: 288.957,
    y2: 372.219
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m389.993 470.667c-1.393 0-2.802-.388-4.059-1.199-3.48-2.246-4.482-6.888-2.236-10.368 4.488-6.957 4.488-19.162 0-26.118-7.667-11.883-7.667-30.499 0-42.382 4.488-6.957 4.488-19.162 0-26.118-7.667-11.883-7.667-30.499 0-42.382 2.247-3.48 6.889-4.481 10.368-2.236 3.48 2.246 4.482 6.888 2.236 10.368-4.488 6.957-4.488 19.162 0 26.118 7.667 11.883 7.667 30.499 0 42.382-4.488 6.957-4.488 19.162 0 26.118 7.667 11.883 7.667 30.499 0 42.382-1.434 2.223-3.846 3.435-6.309 3.435z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m380.794 332.737-29.503 44.702c-4.84 7.334.419 17.107 9.206 17.107h59.006c8.787 0 14.047-9.773 9.206-17.107l-29.503-44.702c-4.36-6.606-14.052-6.606-18.412 0z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.71 377.439-29.503-44.702c-4.36-6.606-14.053-6.606-18.413 0l-15.632 23.685 38.124 38.124h16.218c8.786-.001 14.046-9.774 9.206-17.107z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 239,
    fill: "url(#SVGID_4_)",
    r: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.875 253.5c7.159 59.436 57.759 105.5 119.125 105.5s111.966-46.064 119.125-105.5z",
    fill: "url(#SVGID_5_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m392.437 119.031c-.811-.016-1.622-.031-2.437-.031-66.274 0-120 53.726-120 120s53.726 120 120 120 120-53.726 120-120c0-.815-.015-1.626-.031-2.437z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.993 494.501c-1.393 0-2.802-.388-4.059-1.199-3.48-2.246-4.482-6.888-2.236-10.368 4.488-6.957 4.488-19.162 0-26.118-7.667-11.883-7.667-30.499 0-42.382 4.488-6.957 4.488-19.162 0-26.118-7.667-11.883-7.667-30.499 0-42.382 2.247-3.48 6.889-4.481 10.368-2.236 3.48 2.246 4.482 6.888 2.236 10.368-4.488 6.957-4.488 19.162 0 26.118 7.667 11.883 7.667 30.499 0 42.382-4.488 6.957-4.488 19.162 0 26.118 7.667 11.883 7.667 30.499 0 42.382-1.434 2.223-3.846 3.435-6.309 3.435z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.993 510c-1.393 0-2.802-.388-4.059-1.199-3.48-2.246-4.482-6.888-2.236-10.368 4.488-6.957 4.488-19.162 0-26.118-7.667-11.883-7.667-30.499 0-42.382 4.488-6.957 4.488-19.162 0-26.118-7.667-11.883-7.667-30.499 0-42.382 2.247-3.48 6.889-4.481 10.368-2.236 3.48 2.246 4.482 6.888 2.236 10.368-4.488 6.957-4.488 19.162 0 26.118 7.667 11.883 7.667 30.499 0 42.382-4.488 6.957-4.488 19.162 0 26.118 7.667 11.883 7.667 30.499 0 42.382-1.434 2.223-3.846 3.435-6.309 3.435z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m245.794 307.07-29.503 44.702c-4.84 7.334.419 17.107 9.206 17.107h59.006c8.787 0 14.047-9.773 9.206-17.107l-29.503-44.702c-4.36-6.606-14.052-6.606-18.412 0z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.71 351.772-29.503-44.702c-4.36-6.606-14.053-6.606-18.413 0l-15.632 23.685 38.124 38.124h16.218c8.786 0 14.046-9.773 9.206-17.107z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395 150c0 91.127-106 190-140 190s-140-98.873-140-190 62.68-150 140-150 140 58.873 140 150z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.896 240c33.937 56.179 88.47 100 111.104 100s77.167-43.821 111.104-100z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m251.333 212h-52v95.202c22.327 20.256 43.561 32.798 55.667 32.798 15.349 0 45.37-20.153 73.689-50.644z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m125.877 369.012-26.03 39.44c-4.271 6.47.37 15.093 8.123 15.093h52.061c7.753 0 12.393-8.623 8.123-15.093l-26.03-39.44c-3.848-5.828-12.4-5.828-16.247 0z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.153 408.452-26.03-39.44c-3.847-5.828-12.398-5.828-16.245 0l-13.792 20.897 33.636 33.636h14.309c7.752 0 12.392-8.622 8.122-15.093z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m245.009 204.717c-30.654-30.655-80.355-30.655-111.009 0-30.654-30.654-80.355-30.654-111.009 0-30.654 30.654-30.654 80.355 0 111.009l53.407 53.407c15.277 15.277 35.997 23.86 57.602 23.86 21.605 0 42.325-8.583 57.602-23.86l53.407-53.407c30.655-30.655 30.655-80.355 0-111.009z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.927 272.193c2.446 15.933 9.791 31.26 22.064 43.532l53.407 53.407c15.277 15.277 35.997 23.86 57.602 23.86 21.605 0 42.325-8.582 57.602-23.86l53.407-53.407c12.272-12.272 19.618-27.599 22.064-43.532z",
    fill: "url(#SVGID_17_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBalloons);
export default __webpack_public_path__ + "static/media/icon-balloons.c512ab8e7c218f93f8980a21260b98ac.svg";
export { ForwardRef as ReactComponent };